import Header from './modules/header';
import Anchor from './modules/anchor';
import './common/list/article-list';
import './modules/tabs';
window.addEventListener('DOMContentLoaded', () => {
  new Header();
  new Anchor();

  // Wellness Labの食材タブを今月のタブに切り替える
  if(document.querySelector('.js-ingredients-tabs')) {
    const nowMonth = new Date().getMonth();
    const targetPanelId = `panel${nowMonth + 1}`;
    window.switchToTabSilently?.(targetPanelId);
  }

});
